<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Request a Payment'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {

        <tidy-row>
          <tidy-text [helper]="'Create a one-off payment request. You will get a secure link to send the payer — recurring rent is generated automatically from each lease.'" />
        </tidy-row>

        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Payer name'"
            formControlName="payer_name"
            [form]="form.controls.payer_name"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the payer name'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-select
            [label]="'Payer type'"
            formControlName="payer_type"
            [form]="form.controls.payer_type"
            [items]="payerTypes"
            [icon]="'assets/svg/people-outline.svg'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Property'"
            formControlName="property_name"
            [form]="form.controls.property_name"
            [icon]="'assets/svg/home-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the property'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Unit (optional)'"
            formControlName="unit"
            [form]="form.controls.unit"
            [icon]="'assets/svg/business-outline.svg'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'What is this for?'"
            formControlName="description"
            [form]="form.controls.description"
            [icon]="'assets/svg/create-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please describe the payment'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Amount'"
            formControlName="amount"
            [form]="form.controls.amount"
            [icon]="'assets/svg/cash-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid amount'"
            [type]="'number'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-datepicker
            [label]="'Due date'"
            formControlName="due_date"
            [form]="form.controls.due_date"
            [submitted]="submitted"
            [errorMessage]="'Please select a due date'" />
        </tidy-row>

        <tidy-error-message [text]="errorMessage" />

        <tidy-row class="extra-top-padding">
          <tidy-button [text]="'Create & Get Link'" [action]="createAction" class="primary" />
        </tidy-row>
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
